import { Segment } from '@dna/analytics'

if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super()

        if (!this.hasAttribute('available')) return

        this.errorHtml =
          this.querySelector('template').content.firstElementChild.cloneNode(
            true,
          )
        this.onClickRefreshList = this.onClickRefreshList.bind(this)
        this.fetchAvailability(this.dataset.variantId)
      }

      connectedCallback() {
        this.$pickupAvailabilityParent = this.closest('.pickup-availability')
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl
        if (!rootUrl.endsWith('/')) {
          rootUrl = `${rootUrl}/`
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section')
            this.renderPreview(sectionInnerHTML)
            if (text.includes('is-available')) {
              this.$pickupAvailabilityParent?.classList.add('is-available')
            } else {
              this.$pickupAvailabilityParent?.classList.remove('is-available')
            }
          })
          .catch((e) => {
            const button = this.querySelector('button')
            if (button)
              button.removeEventListener('click', this.onClickRefreshList)
            this.renderError()
          })
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId)
      }

      renderError() {
        this.innerHTML = ''
        this.appendChild(this.errorHtml)

        this.querySelector('button').addEventListener(
          'click',
          this.onClickRefreshList,
        )
      }

      renderPreview(sectionInnerHTML) {
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = ''
          this.removeAttribute('available')
          return
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          'pickup-availability-preview',
        ).outerHTML
        this.setAttribute('available', '')

        document.body.appendChild(
          sectionInnerHTML.querySelector('.pickup-availability-drawer'),
        )

        const $buttons = this.querySelectorAll('button')
        if ($buttons.length)
          for (const $button of $buttons) {
            $button.addEventListener('click', (evt) => {
              const showSingleStore = $button.getAttribute('data-show-single')
              const targetId = evt.target.getAttribute('data-id')
              const $pickupAvailabilityDrawers = document.querySelectorAll(
                '.pickup-availability-drawer',
              )

              // @segment
              Segment.protect(() => {
                if (showSingleStore) {
                  this.Segment.track(
                    this.Segment.CONSTANTS.EVENTS
                      .STORE_AVAILABILITY_STORE_CLICKED,
                    {
                      store_availability_store_name: $button.textContent.trim(),
                    },
                  )
                } else {
                  Segment.track(
                    this.Segment.CONSTANTS.EVENTS
                      .STORE_AVAILABILITY_CHECK_ADDITIONAL,
                  )
                }
              })

              for (const $drawer of $pickupAvailabilityDrawers) {
                const drawerId = $drawer.getAttribute('data-id')
                if (targetId === drawerId) {
                  const $viewAllStoresButton = $drawer.querySelector(
                    '.js-pickup-availability-view-all',
                  )
                  const $pickupAvailabilityList = $drawer.querySelector(
                    '.pickup-availability-list',
                  )
                  if (showSingleStore) {
                    $pickupAvailabilityList.classList.add(
                      'pickup-availability-list--single',
                    )
                    $viewAllStoresButton.classList.remove('hidden')
                  } else {
                    $pickupAvailabilityList.classList.remove(
                      'pickup-availability-list--single',
                    )
                    $viewAllStoresButton.classList.add('hidden')
                  }
                  $viewAllStoresButton.addEventListener('click', (e) => {
                    $pickupAvailabilityList.classList.remove(
                      'pickup-availability-list--single',
                    )
                    $viewAllStoresButton.classList.add('hidden')
                    // @segment
                    this.Segment.protect(() => {
                      this.Segment.track(
                        this.Segment.CONSTANTS.EVENTS
                          .STORE_AVAILABILITY_VIEW_ALL,
                        {
                          store_availability_store_name:
                            $button.textContent.trim(),
                        },
                      )
                    })
                  })
                  $drawer.querySelector('sl-drawer').show()
                  return
                }
              }
            })
          }
      }
    },
  )
}
